import { useTranslation } from "react-i18next";

import { Box } from "@mui/material";
import Title from "../../atoms/Title/Title";
import StyledButton from "../../atoms/StyledButton/StyledButton";
import Text from "../../atoms/Text/Text";
import SpinnerLoader from "../../atoms/SpinnerLoader/SpinnerLoader";

import { Mean } from "../../../types/rtk/mean/mean";
import PaymentMeanCard from "../../molecules/PaymentMeanCard/PaymentMeanCard";

interface Props {
  data: Mean;
  onChangeMean?: () => void;
  isLoading?: boolean;
}

const PaymentMean = ({ data, onChangeMean, isLoading }: Props) => {
  const { t } = useTranslation();
  const mean = data.default_payment_mean;

  return (
    <Box className="PaymentMean">
      <Box className="paymentMeanSubtitleContainer">
        <Title
          variant="h1"
          className="paymentMeanSubtitle"
          children={t("subscription:MANAGE_MEAN.MEAN.TITLE")}
        />
        <Text
          className="paymentMeanTextSubtitle"
          children={t("subscription:MANAGE_MEAN.MEAN.SUBTITLE")}
        />
      </Box>

      {isLoading ? (
        <SpinnerLoader />
      ) : mean ? (
        <PaymentMeanCard
          {...mean}
          onClick={onChangeMean}
        />
      ) : (
        <>
          <Text
            className="paymentMeanNoDefault"
            children={t('subscription:MANAGE_MEAN.MEAN.NO_MEAN.TITLE')}
          />
          <StyledButton
            className="left small"
            children={t("subscription:MANAGE_MEAN.MEAN.NO_MEAN.BUTTON")}
            onClick={onChangeMean}
          />
        </>
      )}
    </Box>
  );
};

export default PaymentMean;
